import React, { forwardRef, useRef, useEffect, useState } from "react";
import ArrowForwardTwoToneIcon from '@mui/icons-material/ArrowForwardTwoTone';
import "./process.css";

const Process = forwardRef((props, ref) => {

    const boxContainerRef = useRef(null);
    const [scrollProgress, setScrollProgress] = useState(0);

    useEffect(() => {
        const handleScroll = (event) => {
            if (boxContainerRef.current) {
                const boxContainer = boxContainerRef.current;
                const rect = boxContainer.getBoundingClientRect();

                const inView = rect.top < window.innerHeight / 2 && rect.bottom > window.innerHeight / 2;

                if (inView) {
                    event.preventDefault();
                    boxContainer.scrollLeft += event.deltaY;

                    const scrollLeft = boxContainer.scrollLeft;
                    const maxScrollLeft = boxContainer.scrollWidth - boxContainer.clientWidth;
                    const progress = maxScrollLeft > 0 ? (scrollLeft / maxScrollLeft) * 100 : 0;

                    setScrollProgress(progress);

                    if (
                        (event.deltaY < 0 && boxContainer.scrollLeft === 0) ||
                        (event.deltaY > 0 && boxContainer.scrollLeft + boxContainer.clientWidth >= boxContainer.scrollWidth)
                    ) {
                        window.scrollBy(0, event.deltaY);
                    }
                }
            }
        };

        window.addEventListener("wheel", handleScroll, { passive: false });

        return () => {
            window.removeEventListener("wheel", handleScroll);
        }

    }, []);

    return (
        <>
            <div ref={ref} className="process-container">
                <h1 className="proc-topic">
                    How we make it happen?
                </h1>
                <div ref={boxContainerRef} className="box-container">
                    {["1", "2", "3", "4", "5"].map((num, index, array) => (
                        <React.Fragment key={num}>
                            <div key={num} className={`procBox `}>
                                <h1 className="proc-num">{num}</h1>
                                <span className="proc-content">
                                    {num === "1" &&
                                        "Our team conducts an in-depth analysis of your industry and competitors. Within just 4–5 days, we deliver a data-backed roadmap designed to boost your online visibility and align with your business objectives."}
                                    {num === "2" &&
                                        "We ensure continuous campaign refinement and competitor tracking, keeping your marketing strategies ahead of the curve and focused on driving consistent, measurable growth."}
                                    {num === "3" &&
                                        "Transparency is at our core. Every month, you'll receive a detailed report packed with performance metrics and insights—giving you full visibility into your progress and results."}
                                    {num === "4" &&
                                        "We prioritize clarity and trust. Expect a monthly report filled with actionable insights and key data points, so you always know how your campaigns are performing."}
                                    {num === "5" &&
                                        "Your success deserves celebration. With monthly reports full of rich analytics and strategic insights, you'll always be informed, empowered, and in control of your growth."}
                                </span>
                            </div>
                            {index < array.length - 1 && (
                                <div className="arrow-container">
                                    <ArrowForwardTwoToneIcon className="res-arrow"/>
                                </div>
                            )}</React.Fragment>
                    ))}
                </div>
                <div className="progress-bar-container">
                    <div className="progress-bar" style={{ width: `${scrollProgress}%` }}></div>
                </div>
                <br />
            </div>
        </>
    )
});

export default Process;